import { render, staticRenderFns } from "./deviceUface.vue?vue&type=template&id=6681294b&"
import script from "./deviceUface.vue?vue&type=script&lang=js&"
export * from "./deviceUface.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports